import React, { useState } from 'react';
import RechargeCard from '../rechargeCard/RechargeCard';
import './RechargeCardList.css';
import thunder_charger_list from '../../assets/thunder_charger_list.svg';
import angle from '../../assets/angle.svg';
import arrowRightBlack from '../../assets/arrow-down-black.svg';

type RechargeCardListProps = {
  recharges: any[];
};

const RechargeCardList: React.FC<RechargeCardListProps> = (
  rechargesProps: any
) => {
  return (
    <>
      {/* 0 Carregadores ativo - N mostra o agrupamento */}
      {rechargesProps.recharges.length === 0 && (
        <div className='no-recharges'></div>
      )}

      {rechargesProps.recharges.length === 1 && (
        <div className='single-recharge'>
          <RechargeCard recharge={rechargesProps.recharges[0]} />
        </div>
      )}

      {/* X Carregadores ativo - Mostra o agrupamento */}
      {rechargesProps.recharges.length > 1 && (
        <div className='group-recharge-list'>
          <div className='group-content'>
            <div className='wrapper-data'>
              <img
                className='thunder-charge-icon'
                alt='thunder-charge-icon'
                src={thunder_charger_list}
              />
              <div className='titleTex'>{rechargesProps.recharges.length}</div>
              <div className='contentText'>carregadores ativos</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default RechargeCardList;
